var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import _merge from "lodash/merge";
import { LoggingModule } from "@pns-fe/sdk-common-modules";
import axios from "axios";
import { getDeviceInfo } from "../../utils/DeviceUtil";
import { getQueryParams } from "../../utils/JsUtils";
const DOMAIN_CHECK_REGEX = /^(https?:\/\/)/;
const NO_TIMEOUT = 0;
class ServiceModule {
  constructor() {
    this._region = "";
    this._bid = "";
    this._debug = false;
    this.init = (config) => {
      LoggingModule.info("[ServiceModule]: init");
      const { region = "", bid = "", appId, domain } = config != null ? config : {};
      this._appId = appId;
      this._region = region;
      this._bid = bid;
      this._domain = domain;
    };
    this.sendRequest = (path, method, data, config) => {
      const urlStr = DOMAIN_CHECK_REGEX.test(path) ? path : `${this._domain}${path}`;
      const url = new URL(urlStr);
      const prevParams = Array.from(url.searchParams.entries()).reduce(
        (map, ele) => {
          const [key, value] = ele;
          if (typeof value !== "undefined" || value !== "") {
            map[key] = value;
          }
          return map;
        },
        {}
      );
      const _a = config != null ? config : {}, { params, timeout } = _a, rest = __objRest(_a, ["params", "timeout"]);
      let paramObj = __spreadValues(__spreadValues(__spreadValues({
        region: this._region,
        aid: this._appId,
        bid: this._bid
      }, prevParams), params != null ? params : {}), getDeviceInfo());
      if (method === "GET" && data && typeof data === "object") {
        paramObj = __spreadValues(__spreadValues({}, paramObj), data);
      }
      const newParams = new URLSearchParams(getQueryParams(paramObj));
      const newUrl = new URL(`${url.origin}${url.pathname}?${newParams.toString()}`);
      const axiosConfig = _merge({}, rest, {
        method,
        timeout: timeout != null ? timeout : NO_TIMEOUT,
        data
      });
      LoggingModule.info("[ServiceModule]: sendRequest start", axiosConfig);
      return axios(newUrl.href, axiosConfig).then((res) => {
        LoggingModule.info("[ServiceModule]: sendRequest finish", res);
        return res;
      }).catch((e) => {
        LoggingModule.error("[ServiceModule]: sendRequest error", e);
        throw e;
      });
    };
    this.destruct = () => {
      LoggingModule.info("[ServiceModule]: destruct");
    };
    if (!ServiceModule._instance) {
      ServiceModule._instance = this;
    }
    return ServiceModule._instance;
  }
}
var ServiceModule_default = new ServiceModule();
export {
  ServiceModule_default as default
};
